import { S25WsMicroResource } from "./MicroServices/S25WsMicroResource";
import { DataAccess } from "../dataaccess/data.access";
import { MicroUtil } from "./MicroServices/micro.util";
import { S25Util } from "../util/s25-util";
import { Timeout } from "../decorators/timeout.decorator";

export class ResourceMicroService {
    public static saveResource(
        payload: Partial<S25WsMicroResource.Item>,
        include?: S25WsMicroResource.IncludeOptions[],
    ) {
        let url = "/micro/resource/list.json";
        url += include?.length ? `?expand=T&include=${include.join("+")}` : "";

        return DataAccess.put<S25WsMicroResource.ContentWrapper>(
            DataAccess.injectCaller(url, "ResourceMicroService.saveResource"),
            MicroUtil.wrapPayloadItem(payload),
        );
    }

    @Timeout
    public static async alterStock(
        resourceIds: number[],
        stock: S25WsMicroResource.Stock[],
        removedVersions: number[],
    ): Promise<S25WsMicroResource.Content> {
        const item: Partial<S25WsMicroResource.Item> = {
            idList: resourceIds,
            stock: stock?.map(({ versionNbr, startDt, endDt, stockLevel }) => ({
                versionNbr,
                startDt,
                endDt,
                stockLevel,
            })),
            remove: { stock: removedVersions?.map((versionNbr) => ({ versionNbr })) },
        };

        const [resp, error] = await S25Util.Maybe(
            ResourceMicroService.saveResource(S25Util.deleteUndefDeep(item), ["stock"]),
        );
        if (error) {
            return Promise.reject(error.content?.error?.message || "Error occurred while saving resource");
        }
        // The response from the backend uses versionNumber, the GET uses versionNbr. Standardize here.
        for (const item of S25Util.array.forceArray(resp?.content?.data?.items)) {
            S25Util.array
                .forceArray(item.stock)
                .forEach((stockItem: S25WsMicroResource.Stock & { versionNumber: number }) => {
                    if (stockItem.versionNumber) {
                        stockItem.versionNbr = stockItem.versionNumber;
                        delete stockItem.versionNumber; // Remove the old key to avoid confusion downstream
                    }
                });
        }

        return resp?.content;
    }
}
